import React from 'react';
import { useTranslation } from '@gamiphy/react-i18n';
import { Box, Typography } from '@mui/material';
import { LoyaltyLevel } from '../../types';
import { useIsSmallScreen } from '../../hooks';
import { useLoyaltyPageContext } from '../../context';
import MobileDisplay from './MobileDisplay';
import DesktopDisplay from './DesktopDisplay';

const Levels:React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useIsSmallScreen();
  const {
    tiers,
    purchase,
    isMobilePreview,
    benefits,
    mobileBenefitsData,
  } = useLoyaltyPageContext();

  const levels = React.useMemo<LoyaltyLevel[]>(() => {
    if (!tiers) {
      return [];
    }

    return (tiers).map((tier, index) => {
      const matchingPurchaseValue = purchase?.values.find((value) => value.tier === tier.order);

      return {
        index,
        id: tier.id,
        name: tier.name,
        tier: tier.order,
        cash: matchingPurchaseValue?.cash || 0,
      };
    });
  }, [tiers, purchase]);

  return (
    <Box
      pt={{
        xs: 4.5,
        sm: 5,
      }}
      sx={{
        backgroundColor: 'background.paper',
      }}
    >
      <Typography
        variant="h1"
        sx={{
          textAlign: 'center',
          pb: {
            xs: 0,
            sm: 4,
          },
        }}
      >
        {t('realUser.tabs.levels', { defaultValue: 'VIP Levels' })}
      </Typography>
      { isMobile || isMobilePreview ? <MobileDisplay levels={levels} mobileBenefitsData={mobileBenefitsData} /> : <DesktopDisplay levels={levels} benefits={benefits} /> }
    </Box>
  );
};

export default Levels;
